<template>
    <div>
        <ContentHeader path-set-type="append" :gameplan-nav="false" />
        <div class="content-wrapper" v-loading="loading">
            <el-row>
                <div class="activity-new" v-if="false">
                    <div class="activity-new-card is-hover-shadow">
                        <div class="title">
                            <div class="left">
                                <span>{{themeBasic.themeName}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="activity-new2">
                    <div class="title" @click="collClick()">
                        <i :class="[orderShow ? 'el-icon-minus' : 'el-icon-plus']"></i>
                        订单明细
                    </div>
                    <div class="activity-new-card2 is-hover-shadow" v-show="orderShow">
                        <div class="item-red">
                            <div class="red"></div>
                            <span style="margin-right:10px">活动基本信息</span>
                            </div>
                        <div class="form">
                            <div class="item">
                                <div class="item-left">活动名称</div>
                                <div class="item-right">
                                    <span>{{themeBasic.themeName}}</span>
                                </div>
                            </div>
                            <div class="item">
                                <div class="item-left">活动执行时间</div>
                                <div class="item-right">
                                    <span>{{getTime(themeBasic.themeStartTime)}}</span>
                                    <span style="margin:0px 5px;">-</span>
                                    <span>{{getTime(themeBasic.themeEndTime)}}</span>
                                </div>
                            </div>
                            <div class="item">
                                <div class="item-left">活动品牌</div>
                                <div class="item-right" v-if="themeBasic.gpPrDTO">
                                    <span>{{themeBasic.gpPrDTO.brandName}}</span>
                                </div>
                            </div>
                            <!-- <div class="item">
                                <div class="item-left">活动提报时间</div>
                                <div class="item-right">
                                    <span>{{getTime(themeBasic.applyStartTime)}}</span>
                                    <span style="margin:0px 5px;">-</span>
                                    <span>{{getTime(themeBasic.applyEndTime)}}</span>
                                </div>
                            </div> -->
                            <div class="item" v-if="themeBasic.gpPrDTO">
                                <div class="item-left">活动子品牌</div>
                                <div class="item-right" >
                                    <span v-if="themeBasic.gpPrDTO.subBrandName">{{themeBasic.gpPrDTO.subBrandName}}</span>
                                    <span v-else>无</span>
                                </div>
                            </div>

                            <div class="item">
                                <div class="item-left">活动渠道</div>
                                <div class="item-right">
                                    {{getChannel(themeBasic.themeChannels,'、')}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- cross渠道 -->
                <div class="cross" style="margin-top:-20px" v-for="item of fullConfig" :key="item.themeChannelCode">
                    <SubmitPop
                        :channelForm="item"
                        :dataForm ='detailList'
                        :queryCondition="queryCondition"
                        @passThrough ='passThrough'
                        @sendBack = 'sendBack'
                        @clickStorename = 'clickStorename'
                        >
                    </SubmitPop>
                </div>
            </el-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import gameplanApi from '../../api/gameplan'
    import ContentHeader from '@/components/content-header'
    import SubmitPop from './components/submit-approval-pop-detail.vue'
    import DialogPop from './components/dialog-pop.vue'
    export default {
      name: 'submit-approval-detail-two',
      components: {
        ContentHeader,
        SubmitPop,
        DialogPop
      },
      data () {
        return {
            active:0,
            stepList:[],
            themeBasic: {},
            detailList: {},
            channelList:[],
            fullConfig:[],
            themeChannelCodes:[],
            themeId:'',
            isPassThroughall:false, // 是否是全部通过
            isSendbackall:false, // 是否是全部退回
            queryCondition:'05',
            orderShow: true,
            loading:false
            // processType: '02',
            // processAction:'02'
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {},
      created () {
        this.themeId = this.$route.query.themeId
        this.employeeLevel = this.userInfo.employeeLevel
        this.init()
      },
      mounted () {},
      updated () {},
      methods: {
        init () {
            this.getDetailinfo()
            this.getUserlevel()
        },
        // 订单明细显示隐藏
        collClick () {
            this.orderShow = !this.orderShow
        },
        getChannel(a,b){
            let themeChannels = a || []
            let arr = themeChannels.map((item) => {
                    return item.themeChannelEnName
                }).join(b)
            return arr
        },
        getTime (timestamp) {
        if (timestamp === 0 || timestamp == null) {
            return ''
        } else {
            var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
            const Y = date.getFullYear() + '-'
            const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
            const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
            // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
            // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
            return Y + M + D
        }
        },
        async getDetailinfo () {
            let params = {
                'themeId':this.themeId,
                'queryCondition':this.queryCondition
            }
            this.loading = true
            let {data} = await gameplanApi.getGamepalnActivityInfo(params)
            if (data.resultCode == '0') {
                this.loading = false
                this.themeBasic = data.resultData.themeInfo.themeBasic
                // this.fullConfig = data.resultData.themeInfo.themeBasic.themeChannels
                this.detailList = data.resultData.themeInfo.detailList
                let arr = []
                for (let item of this.detailList) {
                if (item.themeDetail.themeChannelName && item.themeDetail.themeChannelCode) {
                    arr.push({
                    'themeChannelCode':item.themeDetail.themeChannelCode,
                    'themeChannelName':item.themeDetail.themeChannelName.split('|')[0],
                    'themeChannelEnName':item.themeDetail.themeChannelName.split('|')[1],
                    })
                }       
                }
                let len = arr.length
                for (let i = 0; i < len; i++) {
                for (let j = i + 1; j < len; j++) {
                    if (arr[i].themeChannelCode === arr[j].themeChannelCode) {
                    arr.splice(j, 1)
                    len-- // 减少循环次数提高性能
                    j-- // 保证j的值自加后不变
                    }
                }
                }
                this.fullConfig = arr
            } else {
                this.loading = false
            }
        },
        gamepalnActivityapprove (params) {
            gameplanApi.getGamepalnActivityapprove(params).then(res=>{
                if (res.data.resultCode === '0') {
                    if (params.activityInfoVOList[0].gpActivityInfoDTO.processAction == '02') {
                        if (this.isPassThroughall == true) {
                            this.$message.success('售点提报批量审批已通过');
                            this.$router.go(-1)
                        } else {
                            this.$message.success('售点提报审批已通过');
                            this.$router.go(0)
                        }
                    } else if (params.activityInfoVOList[0].gpActivityInfoDTO.processAction == '03') {
                        if ((this.isSendbackall == true)) {
                            this.$message.success('售点提报批量审批已退回');
                            this.$router.go(-1)
                        } else {
                            this.$message.success('售点提报审批已退回');
                            this.$router.go(0)
                        }
                    }
                } else {
                    console.log('error');
                }
            })
        },
        getIgniteoptions () {
            gameplanApi.getIgniteoptions().then(res=>{
                if (res.data.resultCode == '0') {
                    this.activityIgnite = res.data.resultData.igniteOptions
                }
            })
        },
        getUserlevel () {
            if  (this.employeeLevel == 60 || this.employeeLevel == 70 || this.employeeLevel == 80 ){
                this.active = 1
                this.stepList = [
                    {name:'',index:0,title:'提交'},
                    {name:'',index:1,title:'BU已审批'},
                    {name:'',index:2,title:'HQ审批'},
                    {name:'',index:3,title:'完成'},
                ]
            } else if  (this.employeeLevel == 90 || this.employeeLevel == 100  ){
                this.active = 3
                this.stepList = [
                    {name:'',index:0,title:'提交'},
                    {name:'',index:1,title:'BU已审批'},
                    {name:'',index:2,title:'HQ已审批'},
                    {name:'',index:3,title:'完成'},
                ]
            }
        },
        showSubStep (item) {
            this.active = item
        },
        clickStorename (row) {
            this.$router.push({path:'/gameplan/activityPhoto-salePlace-detail',query:{activityId:row.activityId}})

        },
        // 通过
        passThrough (item) {
            let newArr= [];
            let arrId = [];
            for(let i of item){
                if(arrId.indexOf(i['activityId']) == -1){
                    arrId.push(i['activityId']);
                    newArr.push(i);
                }
            }
            let arr = []
            for (let i of newArr) {
                arr.push({gpActivityInfoDTO:{
                        processType: '02',
                        processAction: '02',
                        activityId: i.activityId
                }})

            }
            let params = {
                activityInfoVOList: arr
            }
            this.gamepalnActivityapprove(params)

        },
        // 退回
        sendBack (item) {
            let newArr= [];
            let arrId = [];
            for(let i of item){
                if(arrId.indexOf(i['activityId']) == -1){
                    arrId.push(i['activityId']);
                    newArr.push(i);
                }
            }
            let arr = []
            for (let i of newArr) {
                arr.push({gpActivityInfoDTO:{
                        processType: '02',
                        processAction: '03',
                        activityId: i.activityId
                }})

            }
            let params = {
                activityInfoVOList: arr
            }
            this.gamepalnActivityapprove(params)
        },
        // 全部通过
        passThroughall () {
           let ThemeInfoVO = {
            activityInfoVOList:[]
            }
            // 新加
            let testDatalist = JSON.parse(JSON.stringify(this.detailList))
            for (let i = 0; i < testDatalist.length; i++) {
                if (testDatalist[i].gpActivityInfoVOList == null) {
                    testDatalist.splice(i, 1);
                    i--;//i需要自减，否则每次删除都会讲原数组索引发生变化
                }
            }
            let newArr1 = []
            for (let i = 0; i < testDatalist.length; i++) {
                for (let j = 0; j <  testDatalist[i].gpActivityInfoVOList.length; j++) {
                    newArr1.push(testDatalist[i].gpActivityInfoVOList[j].gpActivityInfoDTO)
                }

            }
            if (testDatalist.length == 0) {
                this.$message.warning('当前活动相关提报已经全部操作过，返回上一页')
                this.$router.go(-1)
            } else {
                let a = []
                for (let item of newArr1) {
                    a.push({gpActivityInfoDTO:{
                        processType:'02',
                        processAction:'02',
                        activityId:item.activityId,
                        // activityId:item.gpActivityInfoVOList[0].gpActivityInfoDTO.activityId,
                    }})
                }
                ThemeInfoVO.activityInfoVOList = a
                this.isPassThroughall = true
                this.gamepalnActivityapprove(ThemeInfoVO)
            }
        },
        // 全部退回
        sendBackall (item) {
            let ThemeInfoVO = {
                activityInfoVOList:[]
            }
            let testDatalist = JSON.parse(JSON.stringify(this.detailList))
            for (let i = 0; i < testDatalist.length; i++) {
                if (testDatalist[i].gpActivityInfoVOList == null) {
                    testDatalist.splice(i, 1);
                    i--;//i需要自减，否则每次删除都会讲原数组索引发生变化
                }
            }
            let newArr1 = []
            for (let i = 0; i < testDatalist.length; i++) {
                for (let j = 0; j <  testDatalist[i].gpActivityInfoVOList.length; j++) {
                    newArr1.push(testDatalist[i].gpActivityInfoVOList[j].gpActivityInfoDTO)
                }

            }
            if (testDatalist.length == 0) {
                this.$message.warning('当前活动相关提报已经全部操作过，返回上一页')
                this.$router.go(-1)
            } else {
                let a = []
                for (let item of newArr1) {
                    a.push({gpActivityInfoDTO:{
                        processType:'02',
                        processAction:'03',
                        activityId:item.activityId,
                        // activityId:item.gpActivityInfoVOList[0].gpActivityInfoDTO.activityId,
                    }})
                }
                ThemeInfoVO.activityInfoVOList = a
                this.isSendbackall = true
                this.gamepalnActivityapprove(ThemeInfoVO)
            }
        },
        // 返回上一页
        goReturn () {
            this.$router.go(-1)
        },
    }
}
</script>
<style lang="scss" scoped>
    .is-hover-shadow:hover {
        box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .content-wrapper {
        min-height: calc(100vh - 320px) !important;
        font-family: SourceHanSansSC-regular;
        .activity-new {
            .activity-new-card {
                // height: 135px;
                padding: 10px 27px 10px 30px;
                background-color: #FFFFFF;
                color: #101010;
                border-radius: 8px;
                .title {
                    height: 30px;
                    line-height: 30px;
                    text-align: left;
                    color: rgba(16, 16, 16, 1);
                    // margin-bottom: 10px;
                    display: flex;
                    .left {
                        flex: 1;
                        font-size: 20px;
                        font-weight: 600;
                        word-wrap: break-word;
                        word-break: normal;
                        word-break: break-all;
                    }
                    .right {
                        // height: 35px;
                        // line-height: 35px;
                        // margin-top: 12.5px;
                        // margin-right: 2px;
                        height: 32px;
                        line-height: 32px;
                        margin-top: 9px;
                        font-size: 14px;
                        display: flex;
                        color: #FFFFFF;
                        text-align: center;
                    }
                }
                .step {
                    // height: 100px;
                    // line-height: 100px;
                    ::v-deep .el-step__title {
                        color:#666666;
                    }
                    ::v-deep .el-step__title.is-success {
                        color: #101010;
                    }
                    ::v-deep .el-step__head.is-success .el-step__line-inner {
                        background-color: #101010;
                    }
                    ::v-deep .el-step__head.is-success {
                        color: #CD1231;
                        border-color: #CD1231;
                    }
                    ::v-deep .el-step__title.is-process {
                        // font-weight: 700;
                        // color: #303133;
                        font-weight: 500;
                        color: #666666;
                    }
                    ::v-deep .el-step__head.is-process {
                        color: #CD1231;
                        border-color: #CD1231;
                    }
                }
            }
        }
        .activity-new2 {
            // margin-top: 30px;
            .title {
                line-height: 50px;
                text-align: left;
                color: rgba(16, 16, 16, 1);
                font-size: 18px;
                font-weight: 600;
            }
            .activity-new-card {
                padding: 10px 10px 10px 20px;
                background-color: #FFFFFF;
                color: #101010;
                border-radius: 10px;
                font-family: SourceHanSansSC-bold;
                .item-red {
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    font-size: 14px;
                    color: #101010;
                    display: flex;
                    font-weight: bold;
                    .red {
                        width: 50%;
                        display: flex;
                        .line {
                            background-color: #CD1231;
                            width: 3px;
                            border-radius: 2px;
                            height: 20px;
                            line-height: 40px;
                            margin-top: 10px;
                            margin-right: 3px;
                        }
                    }
                    .item {
                        flex: 1;
                        display: flex;
                        .item-left {
                            width: 30%;
                            font-weight: normal;
                        }
                        .item-right {
                            font-weight: normal;
                        }
                    }
                }
                .form{
                    display: flex;
                    flex-wrap: wrap;
                    padding-left: 8px;
                    .item {
                        width: 50%;
                        height: 40px;
                        line-height: 40px;
                        font-size: 14px;
                        color: #101010;
                        display: flex;
                        text-align: left;
                        .item-left {
                            width: 30%;
                        }
                        .item-right {
                            flex: 1;
                        }
                    }
                }
            }
            .activity-new-card2 {
                // margin-top: 30px;
                margin-top: 10px;
                padding: 10px 10px 10px 20px;
                background-color: #FFFFFF;
                color: #101010;
                border-radius: 10px;
                font-family: SourceHanSansSC-bold;
                .item-red {
                    // width: 50%;
                    // height: 40px;
                    line-height: 40px;
                    font-size: 14px;
                    color: #101010;
                    display: flex;
                    font-weight: bold;
                    .red {
                        background-color: #CD1231;
                        width: 3px;
                        border-radius: 2px;
                        height: 20px;
                        line-height: 40px;
                        margin-top: 10px;
                        margin-right: 3px;
                    }
                }
                .form{
                    display: flex;
                    flex-wrap: wrap;
                    padding-left: 8px;
                    .item {
                        width: 50%;
                        // height: 33px;
                        line-height: 33px;
                        font-size: 14px;
                        color: #101010;
                        // padding-left: 3px;
                        display: flex;
                        text-align: left;
                        .item-left {
                            // width: 20%;
                            width: 117px;
                            font-weight: 600;
                        }
                        .item-right {
                            flex: 1;
                            word-wrap: break-word;
                            word-break: normal;
                            word-break: break-all;
                        }
                    }
                }
            }
        }
        .btn-bottom {
            height: 30px;
            line-height: 30px;
            width: 100px;
            margin: 0px auto  ;
            margin-top: 50px;

        }
    }
</style>
